import React from 'react'

const Guide = ({width}) => {

    // ต้องแบ่งเป็น 2 ส่วน ส่วนละ 4 รูป แบ่งตามแนวมือถือและ PC
    return ( 
        <div className='text-center' style={{paddingTop: 100}}>
            {width < 600 ? (
                <h3 className='colorbase'>แนะนำการใช้งานเมนู<br />My GPF & My GPF Twins</h3>
            ) :(
                <h3 className='colorbase'>แนะนำการใช้งานเมนู My GPF & My GPF Twins</h3>
            )}
            <p className='mt-3'>
                ขั้นตอนสำคัญสู่การประมาณการเงิน กบข. ในวันเกษียณที่ตรงใจคุณ เริ่มต้นจากการตั้งเป้าหมายวันเกษียณ จากนั้นสร้าง Twins ของตนเองเพื่อดูประมาณการเงิน กบข. และเปรียบเทียบให้เห็นภาพชัดเจนขึ้น
            </p>
            <img className='mt-3' src={width > 800 ? 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset8.webp' : 'https://gpfimg-cdn.azureedge.net/micrositemygpftwins/Asset7.webp'} width={width > 800 ? '60%' : '100%'} />
        </div>
     );
}
 
export default Guide;